import React from 'react';
import moment from 'moment';
import * as utils from '../date_utils';
import ArrowDownSlimIcon from '../../../common/icons/arrow-down-slim.svg';
import CalendarTime from './calendartime';

export default class CalendarTimeRange extends React.PureComponent {
    constructor(props) {
        super(props);

        this.timeRange = null;
    }

    render() {
        return (
            <div className="timepicker">
                {this.props.isMobile && (<h1>Godzina</h1>)}
                {!this.props.isMobile && (<button className="prev" onClick={ e => {
                    e.preventDefault();
                    this.timeRange.scrollTop -= 30;
                }}><ArrowDownSlimIcon /></button>)}
                <div className="timerangecontainer">
                    <ul className="timerange" ref={el => this.timeRange = el}>
                        {this.props.intervals.filter(interval => utils.isSameDay(moment(interval.cmbDelayedIntervalId), this.props.value)).map(interval => (
                            <CalendarTime key={'CT'+interval.cmbDelayedIntervalHour} interval={interval} value={this.props.value} onTimeClick={this.props.onTimeClick} />
                        ))}
                    </ul>
                </div>
                {!this.props.isMobile && (<button className="next" onClick={ e => {
                    e.preventDefault();
                    this.timeRange.scrollTop += 30;
                }}><ArrowDownSlimIcon /></button>)}
            </div>
        );
    }
}
